import * as React from "react";

import GridItem, { GridWidths } from "@insite/mobius/GridItem";
import Link from "@insite/mobius/Link";
import { MainNavigationStyles, MappedLink } from "@tKgpco/Overrides/Widgets/Header/MainNavigation";

import { getCookie } from "@insite/client-framework/Common/Cookies";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { setMainNavigation } from "@insite/client-framework/Components/ShellHoleConnect";
import { NavigationModeCookieName } from "@insite/content-library/Components/NavigationModeMenu";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer from "@insite/mobius/GridContainer";
import Menu from "@tKgpco/Components/Menu";
import { css, ThemeProps, withTheme } from "styled-components";

interface MainNavigationItemProps {
    link: MappedLink;
    index: number;
    styles: MainNavigationStyles;
    container: React.RefObject<HTMLElement | null>;
    isOpen: boolean;
}

interface OwnProps {
    displayChangeCustomerLink: boolean;
}

interface State {
    hover: boolean;
}

type Props = ThemeProps<BaseTheme> & OwnProps & MainNavigationItemProps;

class MainNavigationItem extends React.Component<Props, State> {
    element = React.createRef<HTMLElement>();
    popover = React.createRef<any>();

    constructor(props: ThemeProps<BaseTheme> & MainNavigationItemProps & OwnProps) {
        super(props);

        this.state = {
            hover: false,
        };
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount(): void {
        setMainNavigation({
            close: () => {
                this.closePopover();
            },
            openMenu: (index: number) => {
                this.openPopover();
            },
        });
    }

    closePopover = () => {
        this.popover.current && (this.popover.current! as any).closePopover();
    };

    openPopover = () => {
        this.popover.current && (this.popover.current! as any).openPopover();
    };

    hoverOn = () => {
        this.setState({ hover: true });
    };
    hoverOff = () => {
        this.setState({ hover: false });
    };
    hoverSublinkOff = () => {
        this.setState({ hover: false });
    };
    render() {
        const {
            styles,
            link,
            index,
            isOpen,
            theme: {
                breakpoints: { maxWidths },
            },
        } = this.props;
        //  const downIcon = <StyledIcon src={ChevronDown} {...styles.menuItemIcon} />;
        const isCascading = link.children && link.children.length > 0 && link.childrenType === "CascadingMenu";
        const isMega = link.children && link.children.length > 0 && link.childrenType === "MegaMenu";

        const columnCount = link.numberOfColumns;
        let menuLink = (
            <Link
                className="menu-item"
                typographyProps={styles.menuItemTypography}
                color={styles.menuItemTypography?.color}
                {...styles.menuItem}
                href={link.isClickable === undefined || link.isClickable ? link.url : ""}
                target={link.openInNewWindow ? "_blank" : ""}
            >
                {link.title}
                {isCascading}
            </Link>
        );
        if (isMega || link.url === "") {
            menuLink = (
                <Link
                    className="menu-item"
                    typographyProps={styles.menuItemTypography}
                    color={styles.menuItemTypography?.color}
                    {...styles.menuItem}
                >
                    {link.title}
                    {isCascading || isMega}
                </Link>
            );
        }

        let menuItem = menuLink;

        if (isCascading && link.children) {
            const menuProps: { maxDepth?: number } = {};
            if (link.maxDepth) {
                menuProps.maxDepth = link.maxDepth;
            }
            menuItem = (
                <Menu
                    className="cascading-menu"
                    data-test-selector={`mainNavigationItem_${index}`}
                    isOpen={isOpen || undefined}
                    descriptionId={`${link.title}_${index}`}
                    menuItems={link.children}
                    menuTrigger={menuLink}
                    displayChangeCustomerLink={this.props.displayChangeCustomerLink}
                    {...menuProps}
                    {...styles.cascadingMenu}
                />
            );
        }

        if (link.subLinks) {
            const subLinks = link.subLinks.split(",");
            menuItem = (
                <StyledWrapper {...styles.customMenu} onMouseOver={this.hoverOn} onMouseOut={this.hoverOff}>
                    <Link
                        typographyProps={styles.menuItemTypography}
                        color={styles.menuItemTypography?.color}
                        {...styles.menuItem}
                        href={link.url}
                    >
                        {link.title}
                    </Link>
                    <StyledWrapper
                        {...(this.state.hover ? { ...styles.openCustomMenu } : { ...styles.closeCustomMenu })}
                        className="customMenuDrawerWrapper"
                        data-test-selector={columnCount}
                    >
                        <StyledWrapper
                            className="GridWrapper"
                            css={css`
                                & ul {
                                    column-count: ${columnCount};
                                }
                            `}
                        >
                            <ul>
                                {subLinks.map((sublink, index) => (
                                    // eslint-disable-next-line react/no-array-index-key
                                    <li key={index}>
                                        <Link
                                            onClick={this.hoverSublinkOff}
                                            href={`${link.url}?id=${sublink.replace(/ /g, "")}`}
                                        >
                                            {sublink}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </StyledWrapper>
                    </StyledWrapper>
                </StyledWrapper>
            );
        }

        if (isMega) {
            menuItem = (
                <StyledWrapper {...styles.megaMenuWrapper} onMouseOver={this.hoverOn} onMouseOut={this.hoverOff}>
                    <Link color={styles.menuItemTypography?.color} {...styles.menuItem} className="shop-label">
                        {link.title}
                        {isCascading || isMega}
                    </Link>
                    <StyledWrapper
                        {...(this.state.hover ? { ...styles.openMegaMenu } : { ...styles.closeMegaMenu })}
                        className="megaMenuDrawerWrapper"
                        data-test-selector={columnCount}
                    >
                        <GridContainer
                            className="mega-menu-grid-container"
                            {...styles.megaMenuGridContainer}
                            offsetProps={{ ...styles.megaMenuGridContainer?.offsetProps, as: "ul" }}
                            css={css`
                                & ul {
                                    column-count: ${columnCount};
                                }
                            `}
                        >
                            {link
                                .children!.filter(child => !child.excludeFromNavigation)
                                .map((child, index) => (
                                    <GridItem
                                        className="mega-menu-grid-item"
                                        width={(12 / link.numberOfColumns!) as GridWidths}
                                        key={index}
                                        {...styles.megaMenuGridItem}
                                        as="li"
                                    >
                                        <Link
                                            className="mega-menu-heading-link"
                                            {...styles.megaMenuHeading}
                                            href={child.url}
                                            onClick={this.hoverOff}
                                        >
                                            {child.title}
                                        </Link>
                                        {child.children && (
                                            <ul
                                                className="subCategoriesLink"
                                                data-test-selector={`linksFor_${child.title}`}
                                            >
                                                {child.children
                                                    // .filter(grandChild => !grandChild.excludeFromNavigation)
                                                    .filter(grandChild => {
                                                        if (grandChild.excludeFromNavigation) {
                                                            return false;
                                                        }
                                                        if (grandChild.type === "VmiUsersPage") {
                                                            const currentMode = getCookie(NavigationModeCookieName);
                                                            if (!currentMode || currentMode === "Storefront") {
                                                                return false;
                                                            }
                                                        }

                                                        return true;
                                                    })
                                                    .map((grandChild, index) => (
                                                        // eslint-disable-next-line react/no-array-index-key
                                                        <li key={index}>
                                                            <Link
                                                                className="mega-menu-link"
                                                                {...styles.megaMenuLink}
                                                                onClick={this.hoverOff}
                                                                href={grandChild.url}
                                                                data-test-selector={grandChild.title}
                                                            >
                                                                {grandChild.title}
                                                            </Link>
                                                        </li>
                                                    ))}
                                            </ul>
                                        )}
                                    </GridItem>
                                ))}
                        </GridContainer>
                    </StyledWrapper>
                </StyledWrapper>
            );
        }

        return menuItem;
    }
}

export default withTheme(MainNavigationItem);
